const supportedSize = (size) => size;
export const itemTheme = {
    layout: {
        normal: {
            sizeVariant: {
                sm: {
                    slotSize: 'md',
                    horizontalMargin: (props) => props.theme.spacing.sm,
                    slotVerticalMargin: (props) => props.theme.spacing.xs,
                },
                md: {
                    slotSize: 'md',
                    horizontalMargin: (props) => props.theme.spacing.sm,
                    slotVerticalMargin: (props) => props.theme.spacing.sm,
                },
                lg: {
                    slotSize: 'lg',
                    horizontalMargin: (props) => props.theme.spacing.sm,
                    slotVerticalMargin: (props) => props.theme.spacing.md,
                },
            },
            oneliner: {
                sm: {
                    verticalMargin: (props) => props.theme.spacing.xs,
                    typographySize: supportedSize('xs'),
                },
                md: {
                    verticalMargin: (props) => props.theme.spacing.sm,
                    typographySize: supportedSize('sm'),
                },
                lg: {
                    verticalMargin: (props) => props.theme.spacing.md,
                    typographySize: supportedSize('md'),
                },
            },
            twoliner: {
                sm: {
                    gap: '0',
                    verticalMargin: (props) => props.theme.spacing.xxs,
                    typographySize: {
                        line1: supportedSize('xxs'),
                        line2: supportedSize('xxs'),
                    },
                },
                md: {
                    gap: '0.125rem',
                    verticalMargin: (props) => props.theme.spacing.xxs,
                    typographySize: {
                        line1: supportedSize('xs'),
                        line2: supportedSize('xxs'),
                    },
                },
                lg: {
                    gap: (props) => props.theme.spacing.xxs,
                    verticalMargin: (props) => props.theme.spacing.xs,
                    typographySize: {
                        line1: supportedSize('sm'),
                        line2: supportedSize('xxs'),
                    },
                },
            },
        },
    },
};
const normalTheme = itemTheme.layout.normal;
export const itemLayoutSizeVariant = (props) => normalTheme.sizeVariant[props.size];
export const onelinerSizeVariant = (props) => normalTheme.oneliner[props.size];
export const twolinerSizeVariant = (props) => normalTheme.twoliner[props.size];
